module.exports = __webpack_public_path__ + "static/media/梁琼麟.8400ccfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/梁琼麟.jpg
// module id = 347
// module chunks = 2